import { useState } from "react";
import { useAuth } from "../App";
import { changePassword } from "../lib/api";
import { toast } from "sonner";

function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default function ForceChangePassword() {
  const { user, refreshUser, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) return toast.error("New password must be at least 6 characters");
    if (next !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await changePassword(current, next);
      toast.success("Password updated");
      await refreshUser();
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Could not change password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: "#0b1e3b" }}>
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl" data-testid="force-change-password">
        <div className="mb-6 flex items-center gap-3">
          <img src="/logo_full.png" alt="SMARTIS" className="h-10 w-auto rounded" />
          <div>
            <h1 className="text-xl font-bold text-[#00305E]">Set a new password</h1>
            <p className="text-sm text-muted-foreground">Welcome{user?.name ? `, ${user.name}` : ""} — please replace your temporary password to continue.</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Temporary / current password</label>
            <input
              type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required
              data-testid="fcp-current" className="w-full rounded-lg border border-slate-300 px-3 py-2 focus:border-[#00305E] focus:outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">New password</label>
            <input
              type="password" value={next} onChange={(e) => setNext(e.target.value)} required
              data-testid="fcp-new" className="w-full rounded-lg border border-slate-300 px-3 py-2 focus:border-[#00305E] focus:outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Confirm new password</label>
            <input
              type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
              data-testid="fcp-confirm" className="w-full rounded-lg border border-slate-300 px-3 py-2 focus:border-[#00305E] focus:outline-none"
            />
          </div>
          <button
            type="submit" disabled={busy} data-testid="fcp-submit"
            className="w-full rounded-lg bg-[#00305E] py-2.5 font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60"
          >
            {busy ? "Saving…" : "Save new password"}
          </button>
          <button type="button" onClick={logout} data-testid="fcp-signout" className="w-full text-center text-sm text-slate-500 hover:text-slate-700">
            Sign out
          </button>
        </form>
      </div>
    </div>
  );
}
